import React, { useContext, useEffect, useState } from "react";
import styles from "./Cart.module.css";
import { IoTrashOutline } from "react-icons/io5";
import axiosPrivate from "../../../hooks/axiosPrivate";
import { Link, useNavigate } from "react-router-dom";
import CartCountContext from "../../../context/CartCount/CartCountContext";
import { successToast } from "../../backend/common/Toaster";
import LoaderContext from "../../../context/Loader/LoaderContext";
import { Dialog } from "primereact/dialog";
import SignIn from "../../auth/SignIn";
import HeaderWithLeaf from "../../HeaderWithLeaf";

function Cart() {
  const navigate = useNavigate();
  const [cartitems, setCartItems] = useState([]);
  const [cart_updation, updateCartItems] = useState(0);
  const [subTotal, setsubTotal] = useState(0);
  const [Total, setTotal] = useState(0);
  const [shipping, setShippingTotal] = useState(0);
  const { setCartCountCheck, setCartCount } =
    useContext(CartCountContext);
  const { setLoaderCheck } = useContext(LoaderContext);
  const [refresh, setRefresh] = useState(false);
  const [showCheckout, setShowCheckout] = useState(false);
  let userLogin = JSON.parse(localStorage.getItem("userData"));
  const [shippingPrice, setShippingPrice] = useState(0);
  const [shippingPriceValue, setShippingPriceValue] = useState(0);
  const [discountPercent, setDiscountPercent] = useState(0);

  const getShippingPrice = (value) => {
    if (!value || value.length === 0) return 0;

    const totalShippingCost = value.reduce((sum, acc) => {
      const cost = parseFloat(acc.shipping_cost) || 0;
      const qty = parseInt(acc.quantity) || 1;
      return sum + cost * qty;
    }, 0);

    if (userLogin?.isFirstOrder) return 0;
    const returnValue = Number(totalShippingCost.toFixed(2));
    setShippingPriceValue(returnValue);
    return returnValue;
  };

  const getCartItems = () => {
    setCartCountCheck((prev) => !prev);
    if (userLogin) {
      setLoaderCheck(true);
      axiosPrivate
        .get("carts/get")
        .then((res) => {
          setCartItems(res?.data?.data);
          setCartCount(res?.data?.data?.length || 0);
          setLoaderCheck(false);
        })

        .catch((error) => {
          setLoaderCheck(false);
          // showErrorToast(error.response?.data?.message)
          if (error?.response?.data?.data?.length == 0) {
            setCartItems([]);
            setCartCount(0);
          }
        });
    } else {
      let cart_local_array = localStorage?.getItem("cart_items");
      if (cart_local_array) {
        let parsed_data = JSON?.parse(cart_local_array);
        setCartItems(parsed_data);
        setCartCount(parsed_data?.length || 0);

        // getShippingPrice(parsed_data);
      } else {
        setCartItems([]);
        setCartCount(0);
      }
    }
    setCartCountCheck((prev) => !prev);
  };
  useEffect(() => {
    getCartItems();
  }, [refresh]);

  //delete cart
  async function deleteItem(res, index) {
    if (!userLogin) {
      // Update local cart items immutably
      const updatedCart = cartitems?.filter((_, i) => i !== index);

      if (updatedCart.length > 0) {
        localStorage.setItem("cart_items", JSON.stringify(updatedCart));
      } else {
        localStorage.removeItem("cart_items");
      }

      setRefresh((prev) => !prev);
      updateCartItems(cart_updation + 1);
      successToast("Cart Item deleted Successfully!");
    } else {
      try {
        setLoaderCheck(true);
        await axiosPrivate.delete(`carts/${res.id}`);
        getCartItems(); // Fetch updated cart items
        successToast("Cart Item deleted Successfully!");
      } catch (error) {
        console.error("Error deleting cart item:", error);
      } finally {
        setLoaderCheck(false);
        setRefresh((prev) => !prev);
      }
    }

    setCartCountCheck((prev) => !prev);
  }

  //get total
  useEffect(() => {
    let subTotal = 0;
    cartitems?.forEach((res) => {
      subTotal = subTotal + (res.rate ?? res?.regular_price) * res.quantity;
    });
    setsubTotal(subTotal);
    //setTotalAmount(totalSaving + orderTotal + taxes + shipping + subTotal);
  }, [cartitems]);

  //get total
  useEffect(() => {
    let Total = 0;
    cartitems?.forEach((res, index) => {
      Total = Total + (res.rate ?? res?.regular_price) * res.quantity;
      if (index == cartitems?.length - 1) {
        Total = Total + shipping;
      }
    });
    setTotal(Total);
    const shippingPrice = getShippingPrice(cartitems);
    const freeShippingAt = 499;
    const discounts = [
      {
        amount: 799,
        discount: 10,
        discount_type: "percentage",
        id: 1,
        is_active: 1,
      },
    ];
    const isFreeShippingAvailable =
      freeShippingAt !== undefined && Total > freeShippingAt;
    setShippingPrice(isFreeShippingAvailable ? 0 : shippingPrice);

    const applicableDiscount = discounts?.find((d) => Total >= d.amount);
    const discountPercent = applicableDiscount
      ? applicableDiscount?.discount
      : 0;
    setDiscountPercent(discountPercent);
    //setTotalAmount(totalSaving + orderTotal + taxes + shipping + subTotal);
  }, [cartitems]);

  function updateQuantity(res, string, index) {
    const updatedCartItems = [...cartitems];

    if (index !== -1) {
      // Case: REMOVE when quantity is 1 -> DELETE item
      if (string === "remove" && updatedCartItems[index].quantity === 1) {
        deleteItem(res, index);
        return; // Exit early
      }
      if (string === "add") {
        updatedCartItems[index].quantity += 1;
      } else if (string === "remove" && updatedCartItems[index].quantity > 1) {
        updatedCartItems[index].quantity -= 1;
      }

      // Update local storage
      localStorage.setItem("cart_items", JSON.stringify(updatedCartItems));

      // Update cart items state
      setCartItems(updatedCartItems); // Update the state with the new array

      if (!userLogin) {
        updateCartItems(cart_updation + 1); // Make sure this function is updating the UI properly
      } else {
        const object = {
          product_id: res.product_id,
          type: string === "add" ? "plus" : "minus",
          quantity: string === "add" ? 1 : -1, // Adjust quantity value for remove
          variant_id: res?.variant_id,
        };
        setLoaderCheck(true);
        axiosPrivate
          .put("/carts/update/" + res.id, object)
          .then((res) => {
            setLoaderCheck(false);
            updateCartItems(cart_updation + 1); // Make sure this function is updating the UI properly
            setRefresh(true);
          })
          .catch((error) => {
            setLoaderCheck(false);
            // Handle error
          });
      }
    }
  }
  const finalAmount = (
    (Number(Total || 0) + Number(shippingPrice || 0)) *
    (1 - Number(discountPercent || 0) / 100)
  )?.toFixed(2);

  return (
    <>
      {!userLogin && (
        <Dialog
          header="Login here"
          visible={showCheckout}
          onHide={() => setShowCheckout(false)}
          style={{ padding: "0px", maxWidth: "90%" }}
        >
          <SignIn isCart={true} />
          {/* <CheckoutOtp /> */}
        </Dialog>
      )}

      <div className={styles.cartContainer}>
        <div className={styles.mainContainer}>
          <div
            className={styles.mainHeadingContainer}
            style={{ marginBottom: "30px" }}
          >
            <HeaderWithLeaf text="Shopping Cart" />
          </div>
        </div>
        <div className="table-responsive">
          <table className="table">
            <thead>
              <th className={styles.productTable}>Product</th>
              <th className={styles.productTable2}>Price</th>
              <th className={styles.productTable2}>Quantity</th>
              <th style={{ minWidth: "8rem" }}>Total Price</th>
              <th className={styles.productTable2}>Remove</th>
            </thead>
            <tbody>
              {cartitems?.length > 0 ? (
                cartitems?.map((res, index) => (
                  <tr>
                    <td>
                      <div className="background_div">
                        {userLogin ? (
                          <div className="d-flex " style={{ gap: "1rem" }}>
                            <div style={{ marginLeft: "-1vw" }}>
                              <img
                                style={{ width: "5rem" }}
                                src={
                                  userLogin
                                    ? process.env.REACT_APP_COMMON_FILE_URL +
                                    "product-variants/" +
                                    res?.variant_iamge[0]?.image
                                    : process.env.REACT_APP_COMMON_FILE_URL +
                                    res?.image
                                }
                                alt="variant"
                                loading="lazy"
                              />
                            </div>
                            <div>
                              <h5>{res?.product_name || res?.name}</h5>
                              <span>Variant : {res?.variant}</span>
                            </div>
                          </div>
                        ) : (
                          <>
                            {
                              <div className="">
                                <img
                                  style={{ width: "5rem" }}
                                  src={`${process.env.REACT_APP_COMMON_FILE_URL +
                                    "product-variants/" +
                                    res.image
                                    }`}
                                  alt="product"
                                  loading="lazy"
                                />
                                {res?.product_name}
                              </div>
                            }
                          </>
                        )}
                      </div>
                    </td>
                    <td>
                      <div>
                        <p>₹{res?.regular_price ?? res?.rate}</p>
                      </div>
                    </td>
                    <td>
                      <div className={styles.buttonGroup}>
                        <button
                          onClick={() => updateQuantity(res, "remove", index)}
                        >
                          -
                        </button>
                        <span> {res.quantity}</span>
                        <button
                          onClick={() => updateQuantity(res, "add", index)}
                          style={{ padding: "inherit" }}
                        >
                          +
                        </button>
                      </div>
                    </td>
                    <td>
                      <div className="">
                        <p>
                          ₹{(res?.regular_price ?? res?.rate) * res?.quantity}
                        </p>
                      </div>
                    </td>
                    <td>
                      <IoTrashOutline
                        size={20}
                        color="red"
                        cursor={"pointer"}
                        onClick={() => deleteItem(res, index)}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <div className="m-2 d-flex flex-column justify-content-start align-items-start gap-2 mt-4">
                  <p className="text-secondary">
                    Looks like you haven't added anything to your cart yet!
                  </p>
                  <Link to={"/urban-gardens"}>
                    <button
                      className={`${styles.cartbutton} ${styles.Carttext} mt-2`}
                    >
                      Shop Now
                    </button>
                  </Link>
                </div>
              )}
            </tbody>
          </table>
        </div>
        <hr />
        <div className="d-flex justify-content-end">
          <div className={`card p-0 ${styles.cart_card}`}>
            {/* 1. Header */}
            <div className="card-header border-bottom">
              <h4 className="mb-0">Cart Total</h4>
            </div>

            {/* 2. Body */}
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <p className={styles.label}>Sub Total:</p>
                  <p className={styles.label}>
                    Shipping: {userLogin?.isFirstOrder ? "(First order)" : ""}
                    {shippingPrice <= 0 &&
                      !userLogin?.isFirstOrder &&
                      shippingPriceValue
                      ? `(order above 499)`
                      : ""}
                  </p>
                  {discountPercent ? (
                    <p className={styles.label}>
                      {" "}
                      Discount {discountPercent}% (order above Rs. 799)
                    </p>
                  ) : null}
                </div>
                <div className="col-6 text-right">
                  <p className={styles.value}>₹ {subTotal}</p>
                  <p className={styles.value}>
                    {shippingPrice > 0 ? `₹ ${shippingPrice}` : "Free"}
                  </p>
                  {discountPercent ? (
                    <p className={styles.value}>
                      - ₹ {(Number(subTotal || 0) - Number(finalAmount || 0)).toFixed(2)}
                    </p>
                  ) : null}

                </div>
              </div>
            </div>

            {/* 3. Footer - Summary Row */}
            <div className="card-footer border-top bg-light py-2">
              <div className="row">
                <div className="col-6 fw-bold">Total:</div>
                <div className="col-6 text-right fw-bold">
                  ₹ {Number(finalAmount || 0).toFixed(2)}
                </div>
              </div>
            </div>


            {/* 4. Footer - Button */}
            <div
              className={`card-footer border-top py-3 ${styles.proceedButton}`}
            >
              <button
                className={styles.cartbutton}
                onClick={() => {
                  setShowCheckout(true);
                  if (userLogin) {
                    navigate("/checkout");
                  }
                }}
              >
                Proceed to Checkout
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(Cart); // Memoize the Cart;
